<template>

     <LoadPrices v-if="idPresupuesto && mostrarPricing == true && mostrarFormulario == true && urlPresupuestos && visible == false"
     :idPresupuesto="idPresupuesto"
     :urlPresupuestos="urlPresupuestos"
     :conversionValue=0
     name=""
     @PonerVisible="PonerVisible"
     >
     </LoadPrices>

    
    <CreateForm v-if="mostrarPricing == true && mostrarFormulario == true && visible == true"
     :QuestionList="$store.state.Formulario.data" 
     FormularioTag="Formulario" 
     :ActiveQuestion="$store.state.Formulario.ActiveQuestion"
     :DataFinal= "$store.state.Formulario.DataFinal"
     :ValidateForm="$store.state.Formulario.ValidateForm"
     :loading="$store.state.Formulario.loading"
     :textoPantallaCarga="$store.state.Formulario.textoPantallaCarga"
    ></CreateForm>

</template>
<script>
  
  
  import CreateForm from './component/CreateForm.vue'
  import LoadPrices from './component/LoadPrices.vue'

  export default {
    name: 'App',
    components : { CreateForm, LoadPrices},
    data: function () {
                return {
                  idPresupuesto: null,
                  mostrarPricing: false,
                  mostrarFormulario: false,
                  visible: false,
                  urlPresupuestos: ""
                  

                }
              },


    mounted: async function() {


          if (this.visible == false)
          {

               if (urlProductos) {

                    if (!this.$store.state.Pricing){

                         await this.$store.dispatch('getDataJson', urlProductos);
                         this.mostrarPricing = true;


                    }



               }

               if (urlFormulario) {

                    if (!this.$store.state.Formulario){

                         await this.$store.dispatch('getDataJson', urlFormulario);
                         this.mostrarFormulario = true;


                    } 

               }

               
          }

          let urlPresupuestos = document.getElementById("urlPresupuestos").value;

          if (urlPresupuestos)
          {

               this.urlPresupuestos = urlPresupuestos;

          }



          let Id_Presupuesto = document.getElementById("idPresupuesto").value;

          if (Id_Presupuesto != "")
          {

               this.idPresupuesto = Id_Presupuesto;

          } else {


               this.visible = true;


          }     
          


    },

    methods: {

          PonerVisible : function(Visible){


               this.visible = Visible;

          }

     }
  
  }
  </script>
